import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { DateSelect } from 'ziphy-web-shared/basic/lib/forms/fields';
import { decodeAndFormatDateObject } from 'ziphy-web-shared/basic/utils/time';
import { getDateSelectProps } from './';
const DateSelectDefault = ({ $element }) => {
    var _a;
    const { fieldProps } = useMemo(() => getDateSelectProps($element), [$element.config]);
    const { config, renderType, field } = $element;
    if (renderType === 'plain') {
        return field.value ? _jsx("span", { children: decodeAndFormatDateObject(field.value) }) : null;
    }
    return (_jsx(DateSelect, Object.assign({ value: (_a = field.value) === null || _a === void 0 ? void 0 : _a.value, onChange: (obj) => field.onChange(obj) }, fieldProps)));
};
export default observer(DateSelectDefault);
